import axios from "axios";
import API from "../helpers/api";
export const deleteMD = (id) => {
  let url = `${API.MDDelete}/${id}`;
  return dispatch => {
    axios.delete(url).then((response) => {
      dispatch({
        type: "MDDeleteSuccess",
        data: response.data
      })
    })
      .catch((error) => {
        dispatch({
          type: "MDDeleteFailure",
          error: "ERROR"
        })
      })
  }
}